import { Link } from 'react-router-dom';

const LINKS = [
  { label: '首页', to: '/' },
  { label: '电影频道', to: '/category/movie' },
  { label: '电视剧频道', to: '/category/tv' },
  { label: '关于我们', to: '/about' },
];

const FRIENDLY = [
  { label: '影视资讯导航', to: '/category/movie' },
  { label: '热门剧集榜', to: '/category/tv' },
  { label: '影迷社区', to: '/about' },
  { label: '版权与免责', to: '/about' },
];

const SOCIALS = [
  { icon: 'ri-weibo-fill', label: '微博' },
  { icon: 'ri-wechat-fill', label: '微信' },
  { icon: 'ri-youtube-fill', label: '视频号' },
  { icon: 'ri-bilibili-fill', label: '哔哩哔哩' },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:pr-6">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-movie-2-line text-xl"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">朋友的妈妈在线</span>
            </div>
            <p className="text-sm leading-relaxed text-background-300">
              聚合最新电影与电视剧资讯，覆盖动作、喜剧、爱情、科幻、悬疑等多元类型，为你快速发现值得一看的高清影视作品。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {SOCIALS.map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-900 text-background-100 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">快速导航</h4>
            <ul className="space-y-2.5">
              {LINKS.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">友情链接</h4>
            <ul className="space-y-2.5">
              {FRIENDLY.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">联系我们</h4>
            <ul className="space-y-3 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-mail-line"></i></span>
                support@pengyoumama-online.com
              </li>
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-customer-service-2-line"></i></span>
                在线反馈：工作日 9:00 - 18:00
              </li>
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-map-pin-line"></i></span>
                内容合作与版权投诉欢迎来函
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-900 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 朋友的妈妈在线 · 本站资源仅供影视资讯浏览，不含播放与下载服务。</p>
          <p>本站内容为演示用途，图文信息均来自公开资料整理。</p>
        </div>
      </div>
    </footer>
  );
}